<div class="cart-item" @click="goToProductDetail" :class="{'has-pdp': item.has_pdp}">
  <div class="image">
    <img :src="getItemImage(item)" :alt="item.product?.title || item.product?.name" />
  </div>
  <div class="description">
    <div class="item-info">
      <div class="brand-holder">
        <div class="brand">{{ item.product.brand.name }}</div>
        <button
          type="button"
          class="iconfont-cross cross-btn"
          @click.stop.prevent="removeCartItem"
          :aria-label="$t('shopping.quickcart.remove')"
        ></button>
      </div>
      <div class="name">{{ item.product.name }}</div>
      <span v-if="item.deal_type" class="beauty-deal-label">{{ item.deal_type }}</span>
      <div>{{ item.product.size }}</div>
    </div>
    <div class="item-actions">
      <div v-if="item.allow_quantity" class="quantity-holder">
        <button
          type="button"
          class="btn-inc"
          :disabled="item.quantity === 1"
          @click.stop.prevent="() => updateCartItemQuantity(item.quantity - 1)"
        >
          -
        </button>
        <div class="quantity">{{ item.quantity }}</div>
        <button
          type="button"
          class="btn-dec"
          @click.stop.prevent="() => updateCartItemQuantity(item.quantity + 1)"
          :disabled="item.quantity === item.max_quantity"
        >
          +
        </button>
      </div>
      <div class="price" :class="{ 'sale-category' :item.product.is_sale }">
        {{ item.total || item.product?.price }}
      </div>
    </div>
  </div>
</div>
